// TimeExtensionEvent.tsx
import React, { useContext } from 'react';
import { BaseRendererProps } from './eventRenderers'; // your type for event logs
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './TimeExtension.css';
import GameAssetsContext from '../../../../../../context/GameAssetContext';
import { getUniversalSourceIcon } from './StatChangeEvent';
import { faClock } from '@fortawesome/free-solid-svg-icons';

/**
 * TimeExtensionEvent: displays an icon for "clock" plus an icon for the source,
 * and the number of seconds extended.
 */
const TimeExtensionEvent: React.FC<BaseRendererProps> = ({ log }) => {
  const { gameWideAssets, championsAssets } = useContext(GameAssetsContext);
  const { itemImages, runes } = gameWideAssets;

  // Pull details from log
  const details = log.details;
  const extendedSpellName = details.extendedSpellName || "UnknownSpell";
  const extendedSeconds = details.extendedSeconds || 0;
  const sourceType = details.sourceType || "Ability";
  const sourceName = details.sourceName || "Unknown";
  const championName = details.championName;  // might store the champion who extended it
  const imageState = log.imageState;         // e.g. "R"

  // Use the universal image fetching function
  const sourceIcon = getUniversalSourceIcon(
    {
      sourceType: sourceType,
      imageState: imageState,
      sourceName: sourceName,
      championName: championName,
    },
    gameWideAssets,
    championsAssets
  );

  return (
    <div className="time-extension-event">
      <div className="time-extension-wrapper">
        {/* Clock icon */}
        <FontAwesomeIcon icon={faClock} className="fa-clock-icon" />
        {/* e.g. +5s */}
        <span className="time-extended-amount">+{Number(extendedSeconds).toFixed(1)}s</span>
      </div>

      {/* Source icon + name */}
      {sourceIcon && (
        <div className="time-extension-source">
          {sourceIcon}
        </div>
      )}
    </div>
  );
};

export default TimeExtensionEvent;
